import * as types from '../../constants/log/storedPowerLogConstants';

export const storedPowerLogListRequest = ({
  page,
  pageLength,
  beginDate,
  endDate,
  accountNo,
  nftUid,
  callback,
  error,
}) => ({
  type: types.STORED_POWER_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  accountNo,
  nftUid,
  callback,
  error,
});
